import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import type { RootState } from "app/store";

export const getCurrentDateString = () => new Date(Date.now()).toISOString();

// Define a type for the slice state
interface ServiceState {
  date: string;
}

// Define the initial state using that type
const initialState: ServiceState = {
  date: new Date().toISOString(),
};

export const serviceSlice = createSlice({
  name: "service",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState,
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    setDate: (state, action: PayloadAction<string>) => {
      state.date = action.payload;
    },
  },
});

export const { setDate } = serviceSlice.actions;

// Other code such as selectors can use the imported `RootState` type
export const getDate = (state: RootState) => state.service.date;

export default serviceSlice.reducer;
